import { render, staticRenderFns } from "./MipLogo.vue?vue&type=template&id=74787f00&"
import script from "./MipLogo.vue?vue&type=script&lang=js&"
export * from "./MipLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports